
<div class="container-fluid p-0">
    <div class="row justify-content-center">
      <div class="col-sm-3 col-lg-6 d-none d-lg-block" >
        <app-artemis-login-page-carousel></app-artemis-login-page-carousel>
      </div>
  
      <div class="col-sm-9 col-lg-6">
        <div class="container form-container ">
            <div class="row g-0">
                <div class="col-md" ><!--banner new-->
                    <app-artemis-login-banner></app-artemis-login-banner>
                </div>
            </div>
            <div class="row mt-3">
                <div class="col-md">
                    <form [formGroup]="form">
                        <div class="form-group m-3">
                            <h1 class="text-center">Forgot Password</h1>
                        </div>
                        <div class="form-group m-3">
                            <p class="text-justify">
                                We will send a confirmation message to your email.
                            </p>
                            <div class="form-group">
                                <label for="username">Email address</label>
                                <input type="email" class="form-control" formControlName="username" />
                                <!--  [ngClass]="{ 'is-invalid': submitted && f.username.errors }" -->
                                <div class="invalid-feedback">
                                    <!-- *ngIf="submitted && f.username.errors"  -->
                                    <div>Username is required</div>
                                    <!-- *ngIf="f.username.errors.required" -->
                                </div>
                            </div>
        
                        </div>
                        <div class="form-group row mx-3">
                            <button class="btn btn-outline-primary col m-1" (click)="sendPasswordResetEmail()">
                        Send Reset Password Link
                        </button>
                        </div>
                    </form>
                </div>
           </div>         
         </div>
          
      </div>
  
    </div>
  </div>



